import React from "react";
import { Layout } from "antd";
import { AppHeader, AppLayout } from "../../components/Layout/AppLayout";
import { TopBar } from "../../components/TopBar/TopBar";
import { Router } from "../../routes/routesController";

const { Header, Content, Footer } = Layout;

export function BasePage({
  token,
}: {
  token: string | undefined;
}): JSX.Element {
  return (
    <Layout>
      <Header>
        <TopBar />
      </Header>
      <Router />
    </Layout>
  );
}
